import { Tooltip as RMWCTooltip, TooltipProps as RMWCTooltipProps } from "@rmwc/tooltip"
import "@rmwc/tooltip/styles"
import { useMemo } from "react"

export type TooltipProps = RMWCTooltipProps & { inModal?: boolean }

export const Tooltip = ({ className: customClassName, inModal, ...rest }: TooltipProps) => {
  const className = useMemo(
    () => (inModal ? [customClassName, `rmwc-tooltip--in-modal`].filter(Boolean).join(` `) : customClassName),
    [customClassName, inModal]
  )

  return <RMWCTooltip {...rest} className={className} />
}

Tooltip.defaultProps = {
  inModal: undefined,
}
